module.exports = __webpack_public_path__ + "static/media/21.420bc686.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/21.png
// module id = 803
// module chunks = 0